/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, total: NonNullable<unknown> }} Consult_StepInputs */

const en_consult_step = /** @type {(inputs: Consult_StepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.n} of ${i?.total}`)
};

const id_consult_step = /** @type {(inputs: Consult_StepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Langkah ${i?.n} dari ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Step {n} of {total}" |
*
* @param {Consult_StepInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_step = /** @type {((inputs: Consult_StepInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_StepInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_step(inputs)
	return en_consult_step(inputs)
});